import * as ROUTES from './routes'


const  siteDate = [
    {
        id: 1,
        name: 'home',
        title: 'Elite Community Credit Union',
        description: 'Elite Community Credit Union secure and reliable banking for all your needs. Get competitive rates, manage your finances on the go, and experience exceptional customer service. Open an account today',
        link: ROUTES.HOME
    },
    {
        id: 2,
        name: 'become a member',
        title: 'Elite Community CU | Become A Member',
        description: "Elite Community Credit Union is committed to meet our members' financial needs and assist them in attaining their financial goals ...",
        link: ROUTES.BECOME_A_MEMBER
    },
    {
        id: 3,
        name: 'contact us',
        title: 'Elite Community CU | Contact Us',
        description: "...Tuesday 7:45 a.m. 4:00 p.m. Wednesday CLOSED Thursday 7:45 a.m. 4:00 p.m. Friday 7:45 a.m. 4:00 p.m. Important NumbersABA#: 271985556NLMS#: 506334 ...",
        link: ROUTES.CONTACT_US
    },
    {
        id: 4,
        name: 'holiday schedule',
        title: 'Elite Community CU | Holiday Schedule',
        description: 'Elite Community Credit Union secure and reliable banking for all your needs. Get competitive rates, manage your finances on the go, and experience exceptional customer service. Open an account today',
        link: ROUTES.HOLIDAY_SCHEDULE
    },
    {
        id: 5,
        name: 'loan rates',
        title: 'Elite Community CU | Loan Rates',
        description: 'New Car Used Vehicles Shared Secured Personal Home Equity **LTV - Loan To Value NLMS#: 506334Note: New Loan Rates Effective 01/01/2018. Rates Subject To ...',
        link: ROUTES.LOAN_RATES
    },
    {
        id: 6,
        name: 'deposite rates',
        title: 'Elite Community CU |  Deposite Rate',
        description: '... DIVIDENDS WILL BE COMPOUNDED AND CREDITED TO ACCOUNTS EVERY QUARTER. Rates subject to change quarterly. Dividends paid Third Quarter, 2018 ...',
        link: ROUTES.DEPOSITE_RATES
    },
    {
        id: 7,
        name: 'checking accounts',
        title: 'Elite Community CU | Checking Accounts',
        description: 'Share Draft (Checking) Accounts A Credit Union Share Draft account is an alternative to a traditional checking account at a bank and offers you ...',
        link: ROUTES.CHECKING_ACCOUNTS
    },
    {
        id: 8,
        name: 'credit card',
        title: 'Elite Community CU | Credit Cards',
        description: 'Loan Application Apply For Credit CardApply Online from Anywhere eZCardInfo eZCardInfoAccess Your Credit Card Easily VISA Account Types The Visa Classic Card has a ...',
        link: ROUTES.CREDIT_CARDS
    },
    {
        id: 9,
        name: 'cu service',
        title: 'Elite Community CU | CU Services',
        description: 'Services and Benefits that help over and over again',
        link: ROUTES.CU_SERVICE
    },
    {
        id: 10,
        name: 'loan application',
        title: 'Elite Community CU | Loan Application Form',
        description: 'Individual Credit: You must complete the Applicant section about yourself and the Other section about your spouse if ...',
        link: ROUTES.LOAN_APPLICATION
    },
    {
        id: 11,
        name: 'calculator',
        title: 'Elite Community CU | Calculator',
        description: 'Savings Calculators What will my savings be worth? How long will it take for my savings goals to be met? What will it take ...',
        link: ROUTES.CALCULATOR
    },
    {
        id: 12,
        name: 'atm locator',
        title: 'Elite Community CU | ATM Locators',
        description: 'Never Fret About Fees Find a free ATM with any of the ATM locators below...',
        link: ROUTES.ATM_LOCATOR
    },
    
]

export default siteDate